import $ from 'jquery';
import formatCarousels from './formatCarousels';
import initCarousels from './initCarousels';

export default () => {
  $(document).on('shopify:section:load', (e) => {
    formatCarousels(`[data-section-id="${e.detail.sectionId}"]`);
    initCarousels(`[data-section-id="${e.detail.sectionId}"]`);
  });
};